import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAll } from 'services/agencies.service';
import { STATUSES } from 'redux/statuses';

export const setAgenciesIfEmpty = createAsyncThunk(
  'agencies/setAgenciesIfEmpty',
  async (payload, { getState }) => {
    try {
      const { data } = await getAll();
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  {
    condition(payload, { getState }) {
      const { agencies } = getState();
      return agencies.status === STATUSES.EMPTY;
    },
  },
);

const initialState = {
  status: STATUSES.EMPTY,
  items: [],
};

const agenciesSlice = createSlice({
  name: 'agencies',
  initialState,
  reducers: {
    setAgencies(state, action) {
      return {
        status: STATUSES.FULFILLED,
        items: action.payload,
      };
    },
    unsetAgencies(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setAgenciesIfEmpty.pending, (state, action) => {
        state.status = STATUSES.PENDING;
      })
      .addCase(setAgenciesIfEmpty.fulfilled, (state, action) => {
        return {
          status: STATUSES.FULFILLED,
          items: action.payload,
        };
      });
  },
});

export const { setAgencies, unsetAgencies } = agenciesSlice.actions;

export default agenciesSlice.reducer;
